import { Box, Button } from "@mui/material";

export const CalendarWithActions = ({
  className,
  children,
  onApply,
  onCancel,
  applyDisabled = false,
}) => {
  return (
    <div className={className}>
      {children}

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 1,
          padding: "12px",
          borderTop: "1px solid #e5e7eb",
          backgroundColor: "#fff",
          borderRadius: "0 0 10px 10px",
        }}
      >
        <Button
          size="small"
          onClick={onCancel}
          sx={{
            textTransform: "none",
            color: "#4b5563",
          }}
        >
          Cancel
        </Button>

        <Button
          size="small"
          variant="contained"
          onClick={onApply}
          disabled={applyDisabled}
          sx={{
            textTransform: "none",
            backgroundColor: "#40518A",
            "&:hover": {
              backgroundColor: "#2d3961",
            },
          }}
        >
          Apply
        </Button>
      </Box>
    </div>
  );
};
